"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var tooltip_1 = require("../tooltip");
var config_context_1 = require("../_util/config-context");
exports.Icon = react_1.forwardRef(function (props, ref) {
    var classPrefix = config_context_1.useConfig().classPrefix;
    var _a = props.type, type = _a === void 0 ? "" : _a, size = props.size, className = props.className, tooltip = props.tooltip, link = props.link, htmlProps = tslib_1.__rest(props, ["type", "size", "className", "tooltip", "link"]);
    var iconClassName = classnames_1.default(className, classPrefix + "-icon", classPrefix + "-icon-" + type, {
        "size-s": size === "s",
        "size-l": size === "l",
    });
    var Parent = link ? "a" : "i";
    var label = type.replace("-blue", "").replace("-hover", "");
    var icon = (react_1.default.createElement(Parent, tslib_1.__assign({ ref: ref, className: iconClassName, role: "img", "aria-label": label }, htmlProps)));
    if (tooltip) {
        return react_1.default.createElement(tooltip_1.Tooltip, { title: tooltip }, icon);
    }
    return icon;
});
exports.Icon.displayName = "Icon";
//# sourceMappingURL=Icon.js.map